import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withAccount } from '../../../../../components/AccountContext';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../../../utils/UrlUtil';
import DefinitionList from './DefinitionList';
import { matchShape } from '../../../../../components/prop-types';

const DEFINITION_FILE_IMPORT = gql`
query ($accountId: ID!,
  $respondentImportId: ID!,
  $filter: RespondentDefinitionFilter,
  $first: Int,
  $after: String,
  $last: Int,
  $before: String
) {
  account(id: $accountId) {
    id
    respondentImport(respondentImportId: $respondentImportId) {
      id
      respondentDefinitions(filter: $filter, first: $first, after: $after, last: $last, before: $before) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            firstName
            lastName
            email
            gender
            locale
            ownEmployee
          }
        }
      }
    }
  }
}

`;

class DefinationListContainer extends Component {
  render() {
    const {
      currentAccount, location, match: { params: urlParams },
      translatedTags,
    } = this.props;
    const params = parse(location.search);
    const pagination = filterPaginationWithSize(params);
    const variables = {
      ...pagination,
      accountId: currentAccount,
      respondentImportId: urlParams.importFileId,
      sort: params.sort,
      filter: params.filter,
    };
    return (
      <Query
        query={DEFINITION_FILE_IMPORT}
        variables={variables}
        fetchPolicy="network-only"
      >
        {({ data, loading, error }) => {
          if (error) return `Error! ${error.message}`;

          const connection = (data && data.account && data && data.account.respondentImport)
            ? data.account.respondentImport.respondentDefinitions
            : emptyConnection();
          return (
            <DefinitionList
              connection={connection}
              currentAccount={currentAccount}
              loading={loading}
              translatedTags={translatedTags}
            />
          );
        }}
      </Query>
    );
  }
}

DefinationListContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  match: matchShape.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const mapState = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

export default connect(
  mapState,
)(withRouter(withAccount(DefinationListContainer)));
